import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  achievementId: number;
  inDropdown?: boolean;
  requestId: number;
  updateAchievements: () => Promise<void>;
}

const AchievementCompletionCancelRequest = ({
  achievementId,
  inDropdown,
  requestId,
  updateAchievements
}: Props) => {
  const { messages } = useReduxState();

  const handleConfirm = async () => {
    try {
      await api.delete(
        `/admin/achievements/${achievementId}/request-access/${requestId}`
      );
      await updateAchievements();
      return true;
    } catch (err) {
      return false;
    }
  };

  return (
    <ConfirmButton
      actionText={messages.commonConfirm}
      buttonCategory="lighter"
      buttonIcon="trash-alt"
      buttonIsDropdown={inDropdown}
      buttonIsRounded={true}
      buttonSize="medium"
      buttonText={messages.profileDeleteCancel}
      category="danger"
      confirmText={messages.accessRequestCancelConfirm}
      confirmTitle={messages.profileDeleteCancel}
      onConfirm={handleConfirm}
      successMessage={messages.profileDeleteCancelSuccess}
      stopPropagation={true}
    />
  );
};

export default AchievementCompletionCancelRequest;
